import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Hook to fetch the stripe_invoicing_enabled platform setting
 */
export function usePlatformInvoicingSetting() {
  return useQuery({
    queryKey: ['platform-setting', 'stripe_invoicing_enabled'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('platform_settings')
        .select('setting_value')
        .eq('setting_key', 'stripe_invoicing_enabled')
        .maybeSingle();
      
      if (error) {
        console.error('Failed to fetch stripe_invoicing_enabled setting:', error);
        return false;
      }
      
      return data?.setting_value === 'true';
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
